import FieldPasteImage from './FieldPasteImage';

export default FieldPasteImage;
